import React, { useState } from "react";
import "../assets/css/resume2.css"; // Importation du CSS
import { useTranslation } from "react-i18next";

const Resume2 = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("experience");
  const [animationClass, setAnimationClass] = useState("");

  const experiences = [
    {
      company: "Devoteam Internal Contribution",
      role: t("ExperienceRole0"),
      date: t("ExperienceDate0"),
      description: t("ExperienceDescription0").split("\n"), 
    },
    {
      company: "Devoteam X Stellantis",
      role: t("ExperienceRole1"),
      date: t("ExperienceDate1"),
      description: t("ExperienceDescription1").split("\n"), 
    },
    {
      company: "Devoteam X Veolia",
      role: t("ExperienceRole2"),
      date: t("ExperienceDate2"),
      description: t("ExperienceDescription2").split("\n"), 
    },
    {
      company: "Devoteam X BTP Consultants",
      role: t("ExperienceRole3"),
      date: t("ExperienceDate3"),
      description: t("ExperienceDescription3").split("\n"), 
    },
    {
      company: "Devoteam X Veolia",
      role: t("ExperienceRole4"),
      date: t("ExperienceDate4"),
      description: t("ExperienceDescription4").split("\n"), 
    },
    {
      company: "Devoteam X SeLoger",
      role: t("ExperienceRole5"),
      date: t("ExperienceDate5"),
      description: t("ExperienceDescription5").split("\n"), 
    },
    {
      company: "Atalian",
      role: t("ExperienceRole6"),
      date: t("ExperienceDate6"),
      description: t("ExperienceDescription6").split("\n"),
    },
  ];

  const education = [
    {
      institution: "Ecole Centrale D'electronique de Paris",
      degree: t("EducationDegree1"),
      date: t("EducationDate1"),
      description: t("EducationDescription1").split("\n"), 
    },
    {
      institution: "Unversidad de europea de madrid",
      degree: t("EducationDegree2"),
      date: t("EducationDate2"),
      description: t("EducationDescription2").split("\n"), 
    },
    {
      institution: "Gustave Eiffel",
      degree: t("EducationDegree3"),
      date: t("EducationDate3"),
      description: t("EducationDescription3").split("\n"), 
    },
  ];

  const handleTabChange = (tab) => {
    if (tab === activeTab) return;
    setActiveTab(tab);
    setTimeout(() => {
      setAnimationClass(tab === "experience" ? "slide-from-left" : "slide-from-right");
    }, 50);
    setTimeout(() => {
      setAnimationClass("");
    }, 500);
  };

  return (
    <section id="Resume2">
      <section className="resume2-section">
        <div className="container">
          <div className="container section-title" data-aos="fade-up">
            <h2 style={{ fontSize: "32px", fontWeight: "bold" }}>{t("ResumeTitle")}</h2>
            <p style={{ fontFamily: "'Cardo', serif", fontSize: "32px", color: "#000" }}>
              {t("ResumeAccroche")}
            </p>
          </div>

          {/* Onglets Experience / Education */}
          <div className="resume-tabs">
            <span className={activeTab === "experience" ? "active" : ""} onClick={() => handleTabChange("experience")}>
              {t("ResumeExperience")}
            </span>
            <span className={activeTab === "education" ? "active" : ""} onClick={() => handleTabChange("education")}>
              {t("ResumeEducation")}
            </span>
          </div>

          {/* La timeline avec l'animation */}
          <div className={`timeline ${animationClass}`}>
            {(activeTab === "experience" ? experiences : education).map((item, index) => (
              <div key={index} className="timeline-item">
                {index % 2 === 0 ? (
                  <>
                    <div className="timeline-content">
                      <h3>{activeTab === "experience" ? item.company : item.institution}</h3>
                      <h4>{activeTab === "experience" ? item.role : item.degree}</h4>
                      {Array.isArray(item.description) ? (
                        <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
                          {item.description.map((point, i) => (
                            <li key={i}>{point}</li>
                          ))}
                        </ul>
                      ) : (
                        <p>{item.description}</p>
                      )}
                    </div>
                    <div className="timeline-dot">{item.date}</div>
                  </>
                ) : (
                  <>
                    <div className="timeline-dot">{item.date}</div>
                    <div className="timeline-content">
                      <h3>{activeTab === "experience" ? item.company : item.institution}</h3>
                      <h4>{activeTab === "experience" ? item.role : item.degree}</h4>
                      {Array.isArray(item.description) ? (
                        <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
                          {item.description.map((point, i) => (
                            <li key={i}>{point}</li>
                          ))}
                        </ul>
                      ) : (
                        <p>{item.description}</p>
                      )}
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </section>
  );
};

export default Resume2;
